import type {Module} from "vuex";
import type {RootState} from "@/store/types";
import {retryRequest} from "@/helpers/request";
import {platform} from "@/api/platform";

export interface UserDelegateState {
    enabled: boolean
}

const delegate: Module<UserDelegateState, RootState> = {
    namespaced: true,
    state: {
        enabled: false
    },
    getters: {
        enabled: (state): boolean => state.enabled
    },
    mutations: {
        setEnabled: (state, enabled: boolean) => state.enabled = enabled,
    },
    actions: {
        fetch(context) {

            return retryRequest(() => platform.get<{results: {allow_delegates: boolean}}>("/api/v2/delegate_config"))
                .then(response => context.commit("setEnabled", response.data.results.allow_delegates));
        },
        clear: context => context.commit("setEnabled", false)
    }
}

export default delegate
